'use strict';
define([], function() {
    function SpeedController($scope, $state, $mdMedia, $stateParams) {
        var vm = $scope;
        vm.$mdMedia = $mdMedia;
        vm.isCurrentTab = $state.$current == 'app.seochecker.results.speed';

        if (!$stateParams.showTab) {
            vm.showTab = 'mobile';
        } else {
            vm.showTab = $stateParams.showTab;
        }

        vm.$watch('performance', function (performance) {
            if (performance && performance.mobile) {
                vm.performanceAuditsAreNotPresent = Object.keys(performance.mobile).length === 0;
            }
        });
    }
    SpeedController.$inject=['$scope', '$state', '$mdMedia', '$stateParams'];
    return SpeedController;
});
